import { defineMessages } from "react-intl";

export default defineMessages({
  title: {
    id: "PageTeamPreSeason.title",
    defaultMessage: "Pre-season",
  },
  subtitle: {
    id: "PageTeamPreSeason.subtitle",
    defaultMessage: "Design exercises and track your squad's progress",
  },
  newExercise: {
    id: "PageTeamPreSeason.newExercise",
    defaultMessage: "New exercise",
  },
  noExercises: {
    id: "PageTeamPreSeason.noExercises",
    defaultMessage: "No pre-season exercises yet. Create the first one!",
  },
  progressFor: {
    id: "PageTeamPreSeason.progressFor",
    defaultMessage: "Progress: {title}",
  },
  selectExercisePrompt: {
    id: "PageTeamPreSeason.selectExercisePrompt",
    defaultMessage: "Select an exercise below to see the progress table",
  },
  viewMatrix: {
    id: "PageTeamPreSeason.viewMatrix",
    defaultMessage: "Day by day",
  },
  viewSummary: {
    id: "PageTeamPreSeason.viewSummary",
    defaultMessage: "Summary",
  },
  summaryFor: {
    id: "PageTeamPreSeason.summaryFor",
    defaultMessage: "Results: {title}",
  },
  columnPlayer: {
    id: "PageTeamPreSeason.columnPlayer",
    defaultMessage: "Player",
  },
  columnCompleted: {
    id: "PageTeamPreSeason.columnCompleted",
    defaultMessage: "Done",
  },
  columnNotDone: {
    id: "PageTeamPreSeason.columnNotDone",
    defaultMessage: "Not done",
  },
  columnPending: {
    id: "PageTeamPreSeason.columnPending",
    defaultMessage: "Pending",
  },
  columnCompletion: {
    id: "PageTeamPreSeason.columnCompletion",
    defaultMessage: "Completion",
  },
  columnTopReason: {
    id: "PageTeamPreSeason.columnTopReason",
    defaultMessage: "Most common reason",
  },
  noReasonsYet: {
    id: "PageTeamPreSeason.noReasonsYet",
    defaultMessage: "—",
  },
  playerSingular: {
    id: "PageTeamPreSeason.playerSingular",
    defaultMessage: "player",
  },
  playerPlural: {
    id: "PageTeamPreSeason.playerPlural",
    defaultMessage: "players",
  },
  // Create dialog
  createDialogTitle: {
    id: "PageTeamPreSeason.createDialogTitle",
    defaultMessage: "New pre-season exercise",
  },
  fieldTitle: {
    id: "PageTeamPreSeason.fieldTitle",
    defaultMessage: "Title",
  },
  fieldTitlePlaceholder: {
    id: "PageTeamPreSeason.fieldTitlePlaceholder",
    defaultMessage: "e.g. Run 5k",
  },
  fieldDescription: {
    id: "PageTeamPreSeason.fieldDescription",
    defaultMessage: "Description (optional)",
  },
  fieldType: {
    id: "PageTeamPreSeason.fieldType",
    defaultMessage: "Exercise type",
  },
  typeRunning: {
    id: "PageTeamPreSeason.typeRunning",
    defaultMessage: "Running (time & distance)",
  },
  typeStrength: {
    id: "PageTeamPreSeason.typeStrength",
    defaultMessage: "Strength (sets, reps & weight)",
  },
  typeGeneric: {
    id: "PageTeamPreSeason.typeGeneric",
    defaultMessage: "Generic (free note)",
  },
  fieldStartDate: {
    id: "PageTeamPreSeason.fieldStartDate",
    defaultMessage: "Start date",
  },
  fieldEndDate: {
    id: "PageTeamPreSeason.fieldEndDate",
    defaultMessage: "End date",
  },
  fieldWeekdays: {
    id: "PageTeamPreSeason.fieldWeekdays",
    defaultMessage: "Days of the week",
  },
  assignmentTitle: {
    id: "PageTeamPreSeason.assignmentTitle",
    defaultMessage: "Assign to",
  },
  assignmentAll: {
    id: "PageTeamPreSeason.assignmentAll",
    defaultMessage: "Whole squad",
  },
  assignmentSelected: {
    id: "PageTeamPreSeason.assignmentSelected",
    defaultMessage: "Selected players",
  },
  cancel: {
    id: "PageTeamPreSeason.cancel",
    defaultMessage: "Cancel",
  },
  create: {
    id: "PageTeamPreSeason.create",
    defaultMessage: "Create",
  },
  deleteConfirmTitle: {
    id: "PageTeamPreSeason.deleteConfirmTitle",
    defaultMessage: "Delete exercise",
  },
  deleteConfirmMessage: {
    id: "PageTeamPreSeason.deleteConfirmMessage",
    defaultMessage:
      "This will remove the exercise and every player's recorded progress for it. This can not be undone.",
  },
  deleteAction: {
    id: "PageTeamPreSeason.deleteAction",
    defaultMessage: "Delete",
  },
  monday: { id: "PageTeamPreSeason.monday", defaultMessage: "Mon" },
  tuesday: { id: "PageTeamPreSeason.tuesday", defaultMessage: "Tue" },
  wednesday: { id: "PageTeamPreSeason.wednesday", defaultMessage: "Wed" },
  thursday: { id: "PageTeamPreSeason.thursday", defaultMessage: "Thu" },
  friday: { id: "PageTeamPreSeason.friday", defaultMessage: "Fri" },
  saturday: { id: "PageTeamPreSeason.saturday", defaultMessage: "Sat" },
  sunday: { id: "PageTeamPreSeason.sunday", defaultMessage: "Sun" },
  reasonInjury: { id: "PageTeamPreSeason.reasonInjury", defaultMessage: "Injury" },
  reasonIllness: { id: "PageTeamPreSeason.reasonIllness", defaultMessage: "Illness" },
  reasonTravel: { id: "PageTeamPreSeason.reasonTravel", defaultMessage: "Travel" },
  reasonRest: { id: "PageTeamPreSeason.reasonRest", defaultMessage: "Rest day" },
  reasonOther: { id: "PageTeamPreSeason.reasonOther", defaultMessage: "Other" },
});
